<template>
  <div>
    <div class="view-container end-0 me-2 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div class="body-title">Historial de Caja</div>
      </div>

      <div class="content-view">
        <table class="table table-hover table-bordered">
          <thead class="border-bottom text-center">
            <th class="col">Id</th>
            <th class="col">Apertura</th>
            <th class="col">Efectivo</th>
            <th class="col">Transferencia</th>
            <th class="col">Estado</th>
            <th class="col">Fecha Ini</th>
            <th class="col">Fecha Fin</th>
          </thead>
          <tbody>
            <tr v-for="cashRegister,i in cashRegisters" :key="i" @click="selectedCashR = cashRegister"
              data-bs-toggle="modal" data-bs-target="#invoiceDetail" class="text-center">

              <td class="ps-3">#0{{cashRegister.id}}</td>
              <td class="pe-4">
                <div class="d-flex justify-content-between">
                  <span>RD$</span>
                  {{formatNumber(cashRegister.opening)}}
                </div>
              </td>
              <td class="pe-4">
                <div class="d-flex justify-content-between">
                  <span>RD$</span>
                  {{formatNumber(cashRegister.total_cash)}}
                </div>
              </td>
              <td class="pe-4">0.00</td>
              <td class="pe-4">{{cashRegister.status}}</td>
              <td class="">{{dateTimeFormat(cashRegister.created_at)}}</td>
              <td class="">{{dateTimeFormat(cashRegister.updated_at)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modals -->
      <!-- CashRegister Details -->
      <div class="modal fade" id="invoiceDetail" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md custom-modal-size" >
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5 class="modal-title fw-bold" id="exampleModalLabel">Detalle de Caja</h5>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <div class="col-12 row px-2 mx-0">
                <!-- Header -->
                <div class="col-12 d-flex flex-column justify-content-between p-0 mb-2">
                  <label class="fw-bold">Monto de apertura:</label>
                  <div class="col-4">
                    <div class="form-group col-10 m-0">
                      <CurrencyInput
                        @keydown.enter="enterAsTab"
                        type="text"
                        class="form-control text-center"
                        v-model="selectedCashR.opening"
                        disabled
                        required>
                      </CurrencyInput>
                    </div>
                  </div>
                </div>

                <!-- Body -->
                <div class="d-flex justify-content-between px-3 gap-2">
                  <!-- Monedas container -->
                  <div class="col-5 row">
                    <h5 class="fw-bold ms-1 mb-2 p-0">Monedas:</h5>
                    <!-- Fila 1 -->
                    <div class="d-flex p-0 gap-1 mb-2">
                      <!-- Monedas de 1 -->
                      <div class="col-6 p-0 money-info">
                        <div class="info-header">
                          <span>RD$ 1</span>
                        </div>
                        <div class="info-body">
                          <span>{{selectedCashR.coin_1}}</span>
                        </div>
                      </div>

                      <!-- Monedas de 5 -->
                      <div class="col-6 p-0 money-info">
                        <div class="info-header">
                          <span>RD$ 5</span>
                        </div>
                        <div class="info-body">
                          <span>{{selectedCashR.coin_5}}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Fila 2 -->
                    <div class="d-flex p-0 gap-1">
                      <!-- Monedas de 10 -->
                      <div class="col-6 p-0 money-info">
                        <div class="info-header">
                          <span>RD$ 10</span>
                        </div>
                        <div class="info-body">
                          <span>{{selectedCashR.coin_10}}</span>
                        </div>
                      </div>

                      <!-- Monedas de 25 -->
                      <div class="col-6 p-0 money-info">
                        <div class="info-header">
                          <span>RD$ 25</span>
                        </div>
                        <div class="info-body">
                          <span>{{selectedCashR.coin_25}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex mt-3 p-0">
                      <h5 class="fw-bold">Total de monedas:</h5>
                      <span class="ps-1">{{ formatNumber(selectedCashR.total_coins) }}</span>
                    </div>
                  </div>

                  <!-- Billetes Container -->
                  <div class="col-7 d-flex flex-column">
                    <h5 class="fw-bold ms-1 mb-2 p-0">Billetes:</h5>
                    <div class="d-flex flex-column">
                      <!-- Fila de billetes -->
                      <div class="d-flex p-0 gap-1 mb-2">
                        <!-- Billetes de 50 -->
                        <div class="col-4 p-0 money-info">
                          <div class="info-header">
                            <span>RD$ 50</span>
                          </div>
                          <div class="info-body">
                            <span>{{selectedCashR.bill_50}}</span>
                          </div>
                        </div>

                        <!-- Billetes de 100 -->
                        <div class="col-4 p-0 money-info">
                          <div class="info-header">
                            <span>RD$ 100</span>
                          </div>
                          <div class="info-body">
                            <span>{{selectedCashR.bill_100}}</span>
                          </div>
                        </div>

                        <!-- Billetes de 200 -->
                        <div class="col-4 p-0 money-info">
                          <div class="info-header">
                            <span>RD$ 200</span>
                          </div>
                          <div class="info-body">
                            <span>{{selectedCashR.bill_200}}</span>
                          </div>
                        </div>
                      </div>

                      <!-- Fila de billetes -->
                      <div class="d-flex p-0 gap-1">
                        <!-- Billetes de 500 -->
                        <div class="col-4 p-0 money-info">
                          <div class="info-header">
                            <span>RD$ 500</span>
                          </div>
                          <div class="info-body">
                            <span>{{selectedCashR.bill_500}}</span>
                          </div>
                        </div>

                        <!-- Billetes de 1000 -->
                        <div class="col-4 p-0 money-info">
                          <div class="info-header">
                            <span>RD$ 1000</span>
                          </div>
                          <div class="info-body">
                            <span>{{selectedCashR.bill_1000}}</span>
                          </div>
                        </div>

                        <!-- Billetes de 2000 -->
                        <div class="col-4 p-0 money-info">
                          <div class="info-header">
                            <span>RD$ 2000</span>
                          </div>
                          <div class="info-body">
                            <span>{{selectedCashR.bill_2000}}</span>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex mt-3 p-0">
                        <h5 class="fw-bold">Total de billetes:</h5>
                        <span class="ps-1">{{ formatNumber(selectedCashR.total_bills) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CurrencyInput from '../CurrencyInputComponent.vue';

  export default {
    components:{
      CurrencyInput
    },

    data(){
      return {
        cashRegisters	: [],
        selectedCashR	: {},
      };
    },
    methods:{
      getCashRegisters(){
        axios.get('/cashregister/get-all-cash-register')
        .then(response => {
          this.cashRegisters = response.data.cashRegisters;
        });
      },

      productTotal(price,qty){
        if(qty == ''){ qty = 0 }
        return isNaN(qty) ? 0 : (price * qty).toFixed(2);
      },
    },
    mounted(){
      this.getCashRegisters();
    }
  }
</script>

<style lang="scss" scoped>
  table.table {
    border-color: #F5F5F5 !important;
    thead > th {
    padding:10px 15px !important;
    }
    tbody > tr > td {
    padding-left: 15px /* !important */;
    }
  }


  .custom-modal-size{
    max-width: 650px;
  }
</style>
